import { useContext, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { config } from "../../constants/config";
import Preloader from "../Preloader";
import NetworkError from "../NetworkError";
import { confirmAlert } from "react-confirm-alert";
import 'react-confirm-alert/src/react-confirm-alert.css';
import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import Nomen from "./nomen";
import UserContext from "../../contexts/UserContext";
import PaginationSelect from "../sPaginationSelect";
import { textes } from "../../constants/textes";




export default function NomensDomaine({ nomtab, type, parent, list, domain }) {
    // states
    const { user, logoutUser } = useContext(UserContext);
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [fetching, setFetching] = useState(false);
    const [deleting, setDeleting] = useState(false);
    const [editedstate, setEditedstate] = useState(false);
    const [error, setError] = useState(false);
    const [nomenlist, setNomentlist] = useState([]);

    const [nbpage, setNbpage] = useState(1);
    const [page, setPage] = useState(0);
    const [currentpage, setCurrentpage] = useState('');


    const showErrorMessage = (msg) => {
        toast.error(msg, {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
        });
    }

    const showSuccesMessage = (msg) => {
        toast.success(msg, {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
        });
    }


    const getNomenList = async (p) => {
        setLoading(true);

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        myHeaders.append("token", config.domain.PUBLICKEY);
        myHeaders.append("apikey", user.token);
        myHeaders.append("cpte", user.code);
        myHeaders.append("prof", user.profil);
        myHeaders.append("conn", user.espace);

        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            // body: urlencoded,
            redirect: 'follow'
        };

        // console.log("data send", urlencoded)

        await fetch(`${config.domain.BASE_URL}/${config.domain.PROJECT}/nouns?nomtab=${nomtab}&page=${p + 1}`, requestOptions).then((response) => {
            if (response?.status === 200) {
                response.json().then(async (data) => {
                    // console.log("resonse jsondecode", data);
                    if (data?.head) {
                        let clientarray = [];

                        clientarray = data?.body?.data;
                        setNbpage(data?.body?.pages);

                        setNomentlist(clientarray);
                        setLoading(false);
                    } else {
                        if (data?.body?.msg === "expiredsession") {
                            logoutUser();
                            navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                        } else {
                            setError(true);
                            setLoading(false);
                        }
                    }
                });
            } else if (response?.status === 401) {
                logoutUser();
                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
            } else {
                setError(true);
                setLoading(false);
            }

        }).catch((err) => {
            // console.log("error", err);
            setError(true);
            setLoading(false);
        });
    }



    // comportements
    useEffect(() => {
        getNomenList(page);
    }, []);

    const handleDelete = async (codeac) => {
        confirmAlert({
            title: 'Supprimer?',
            message: 'Etes vous sûr de vouloir supprimer cette nomenclature?',
            buttons: [
                {
                    label: "Confirm",
                    style: {
                        backgroundColor: '#01203f',
                        color: "#ffffff"
                    },
                    onClick: async () => {

                        setDeleting(true);

                        var myHeaders = new Headers();
                        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
                        myHeaders.append("token", config.domain.PUBLICKEY);
                        myHeaders.append("apikey", user.token);
                        myHeaders.append("cpte", user.code);
                        myHeaders.append("prof", user.profil);
                        myHeaders.append("conn", user.espace);

                        var requestOptions = {
                            method: 'DELETE',
                            headers: myHeaders,
                            // body: urlencoded,
                            redirect: 'follow'
                        };


                        // console.log("data send", urlencoded);

                        await fetch(`${config.domain.BASE_URL}/${config.domain.PROJECT}/nouns/${codeac}`, requestOptions).then((response) => {
                            if (response?.status === 205) {
                                setDeleting(false);
                                showSuccesMessage("Nomenclature supprimé avec succès.");
                                getNomenList(page);
                            } else if (response?.status === 200) {
                                response.json().then(async (data) => {
                                    // console.log("resonse delete", data);
                                    if (data?.body?.msg === "expiredsession") {
                                        logoutUser();
                                        navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                                    } else if (data?.body?.msg === "cette nomenclature est actuellement en utilisation") {
                                        setDeleting(false);
                                        showErrorMessage("Impossible de supprimer une nomenclature utilié");
                                    } else {
                                        setDeleting(false);
                                        showErrorMessage(textes.fr.oparationfail);
                                    }

                                });
                            } else if (response?.status === 401) {
                                logoutUser();
                                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                            } else {
                                // setError(true);
                                showErrorMessage(textes.fr.serviceunavaillable);
                                setDeleting(false);
                            }

                        }).catch((err) => {
                            // console.log("error", err);
                            // setError(true);
                            showErrorMessage("Service indisponible! Veuillez reassayer plutard.");
                            setDeleting(false);
                        });
                    }
                },
                {
                    label: "Cancel",
                    style: {
                        backgroundColor: '#ff0000',
                        color: "#ffffff"
                    },
                    onClick: async () => {
                        // console.log("cancel");
                    }
                }
            ],
            closeOnClickOutside: false
        })
    }

    // console.log(mode && mode["value"]);

    // affichages
    return (
        <>
            {loading && <Preloader />}
            {!loading && error && <NetworkError />}
            {!loading && !error && <div className="row">
                <div className="col-md-12 mb-3 pt-3 rounded" style={{ borderTop: "1px solid #ccc" }}>
                    <div className="row">
                        <div className="col-md-2 mb-3">
                            <PaginationSelect nbpage={nbpage} getList={getNomenList} page={page} setPage={setPage} current={currentpage} setCurrent={setCurrentpage} />
                        </div>
                        {/* <div className="col-md-10 mb-3">
                            <Search 
                                chaine={chaine}
                                setChaine={setChaine}
                                search={searchScan}
                                placeholder="Search by access name..."
                            />
                            <Filterdate 
                                date={date}
                                setDate={setDate}
                                filterdate={filterByDate}
                                placeholder="Filter by date..."
                            />
                            <Filterselect 
                                list={list}
                                item={mode}
                                setItem={setMode}
                                filterselect={filterByMode}
                                placeholder="Filter by access types..."
                            />
                        </div> */}
                        <div className="col-md-12">
                            <div className="card shadow mb-4">
                                <div className="card-header py-3">
                                    <button onClick={() => navigate(-1)} data-toggle="tooltip" title="Quit" data-placement="left" className="btn-shadow ml-3 btn btn-dark btn-sm float-right">
                                        <i className="fa fa-reply"></i> <span>Go Back</span>
                                    </button>
                                    <Link to={`/new-nomen/${nomtab}/${domain}/${type}/${parent}`} data-toggle="tooltip" title="Nouvelle nomenclature" data-placement="left" className="btn-shadow ml-3 btn btn-primary btn-sm float-right">
                                        <i className="fa fa-plus mr-1"></i> <span>Ajouter</span>
                                    </Link>
                                    <h6 className="m-0 ">{list}</h6>
                                </div>
                                <div className="card-body">
                                    <div className="table-responsive mb-3">
                                        <table className="mb-0 table table-bordered">
                                            <thead className="bg-primary">
                                                <tr className="bg-primary text-white">
                                                    <th className="text-center">#</th>
                                                    <th>Libelle</th>
                                                    <th>Abréviation</th>
                                                    <th>Parent</th>
                                                    <th className="text-center">Actions</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {(nomenlist.length === 0) && <tr style={{ borderStyle: "none" }}>
                                                    <th colSpan={4} className="text-center">Aucune nomenclature trouvée pour ce domaine</th>
                                                </tr>}
                                                {
                                                    (nomenlist.length > 0) && nomenlist?.map((item, index) => (
                                                        <Nomen nomen={item} position={(config.secure.limit * page) + index} key={index}
                                                            deleteClick={() => handleDelete(item?.code)}
                                                        />
                                                    ))
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                    {/* <Pagination table={"client"} getList={getNomenList} page={page} setPage={setPage} /> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>}
        </>
    )

}